<!--
================================================
Un composant qui affiche un Welcome tour (via driver js https://github.com/kamranahmedse/driver.js)

Le composant s'affiche si l'utilisateur n'a aucun timerecord

Url d'accès : http://localhost:8080/fr/cronocloud-inc/timeclock
// @deprecated @since 0.30.1

*

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="WelcomeTourComp">
<!--        {{'Hello ! :) I am ' + $options.name}}-->
    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'

    import Driver from "driver.js"
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'WelcomeTourComp', //utile dans vue dev tool
        mixins: [TrackingMixin],
        // components: {},
        data: function () {
            return {
                locale : this.$route.params.locale,
                // =================================================================
                driver: null, // objet driver.js
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                // user: state => state.user,
            }),

        },

        methods: {

            /**
             * Configure le tour driver.js
             */
            setupTour() {
                let self = this;
                this.driver = new Driver({
                    opacity: 0.2,// Background opacity (0 means only popovers and without overlay
                    nextBtnText: self.$t('suivant'),
                    prevBtnText: self.$t('précédent'),
                    doneBtnText: self.$t('terminer'),
                    closeBtnText: self.$t('fermer'),
                    allowClose: false,// Whether the click on overlay should close or not

                });

                // Define the steps for introduction
                this.driver.defineSteps([
                    {
                        element: '#AppNavbarComp .logo',
                        popover: {
                            className: 'first-step-popover-class',
                            title: self.$t('welcomeTourTitle0'),
                            description: self.$t('welcomeTourStep0'),
                            position: 'bottom',
                            offset: 60
                        },
                        onNext: () => {
                            self.$mixpanel.track("welcome tour step 1 displayed");
                            self.ga4GlobalEventTrack('tour step 1 displayed' , {})

                        }
                    },
                    {
                        element: '.clockInOutBtns',
                        popover: {
                            title: self.$t('welcomeTourStep1'),
                        },
                        onNext: () => {
                            self.$mixpanel.track("welcome tour step 2 displayed");
                            self.ga4GlobalEventTrack('tour step 2 displayed' , {})

                        }
                    },

                    {
                        element: '#MyRecentActivityComp .column',
                        popover: {
                            title: self.$t('welcomeTourStep2'),
                        },
                        onNext: () => {
                            self.$mixpanel.track("welcome tour step 3 displayed");
                            self.ga4GlobalEventTrack('tour step 3 displayed' , {})

                        }
                    },

                    {
                        element: '#TimerecordsActivityChartsComp',
                        popover: {
                            title: self.$t('welcomeTourStep3'),
                        },
                        onNext: () => {
                            self.$mixpanel.track("welcome tour step 4 displayed");
                            self.ga4GlobalEventTrack('tour step 4 displayed' , {})

                        }
                    },
                    {
                        element: '#AppNavbarComp',
                        popover: {
                            title: self.$t('welcomeTourStep4'),
                            position: 'bottom',
                            offset: 60

                        },onNext: () => {
                            self.$mixpanel.track("welcome tour last step displayed");
                            self.ga4GlobalEventTrack('welcome tour last step displayed' , {})
                        }
                    },

                ]);

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            // si l'evenement no_timerecord_2_load_event a été déclenché...
            this.$root.$on('no_timerecord_2_load_event', () => {

                this.setupTour()
                this.driver.start()
                this.$mixpanel.track("welcome tour displayed");
                this.ga4GlobalEventTrack('Welcome tour displayed' , {})

            })
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../../node_modules/driver.js/dist/driver.min.css";


    // customisation du css de driverjs
    .driver-popover-title{
        /*color:red;*/
        font-size: 0.95rem !important;
        font-weight: normal !important;
        b{
            font-weight: bold;
        }
    }

    .founderPic{ // ce marquage est directement dans les catalogues ( voir fr.json)
        height: 2.5rem;
        width: 2.5rem;
        margin: auto;
        display: block;
    }

</style>
<style scoped lang="scss">
    /*@import "../assets/css/globalVar.scss";*/
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

</style>
